export enum messageTypes {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
    REJECTED = 'rejected'
}
